import { makeCancellableAPIRequest } from "./index";


export const CheckMarxIntegrationAPI = {
    postConfiguration(data) {
        return makeCancellableAPIRequest(
            "POST",
            "/user/tools/checkmarx",
            {
                data,
            }
        )
    }
}

const IntegrationsAPI = {
    getAllAPIKeys(){
        return makeCancellableAPIRequest(
            "GET",
            "/user/apikey"
        )
    },
    createNewAPIKey({
        expiry,
        role,
        name,
        apiTokenType = "APP_SEC_TOOL",
        productIds,
        accessOnAllProducts,
        accountLevelToken,
        userId,
    }){
        return makeCancellableAPIRequest(
            "POST",
            "/user/apikey",
            {
                data: {
                    expiry,
                    role,
                    name,
                    apiTokenType,
                    productIds,
                    accessOnAllProducts,
                    accountLevelToken,
                    userId
                }
            }
        )
    },
    updateAPIKey({
        role,
        name,
        apiTokenType,
        productIds,
        accessOnAllProducts,
        editId,
        accountLevelToken,
        userId,
    }){
        return makeCancellableAPIRequest(
            "PUT",
            `/user/apikey/${editId}`,
            {
                data: {
                    role,
                    name,
                    apiTokenType,
                    productIds,
                    accessOnAllProducts,
                    accountLevelToken,
                    userId
                }
            }
        )
    },
    activateDeactivateAPIkey(id, status){
        return makeCancellableAPIRequest(
            "PUT",
            "/user/apikey/" + id,
            {
                data: {
                    active: status
                }
            }
        )
    },
    deleteAPIkey(id){
        return makeCancellableAPIRequest(
            "DELETE",
            "/user/apikey/" + id
        )
    },
    createArmorcodeAgent(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/agents",
            {
                data,
            }
        )
    },
    getArmorcodeAgents(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/agents",
        )
    },
    getArmorCodeAgentsV2(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/ac-agent/config/all"
        )
    },
    getArmorCodeAgentsWebStatus(){
        return makeCancellableAPIRequest(
            "GET",
            "/api/ac-agent/status"
        )
    },
    createArmorCodeWebAgentConfig(data){
        return makeCancellableAPIRequest(
            "POST",
            "/api/ac-agent/config",{
                data
            }
        )
    },
    deleteArmorcodeAgent(id){
        return makeCancellableAPIRequest(
            "DELETE",
            `/api/ac-agent/${id}`
        )
    },
    triggerConfiguration(data,toolName){
        return makeCancellableAPIRequest(
            "POST",
            `/user/tools/generic/import/?toolName=${toolName}`,
            {
                data,
            }
        )
    },
    getUsedJiraConfiguration(id){
        return makeCancellableAPIRequest(
            "GET",
            `/user/tickets/jira/configuration/stats/${id}`
        )
    }
}

export default IntegrationsAPI;
